import React, { useState } from "react";
import { useEffect } from "react";
import Eligibility from "../CommonComponents/Eligibility/Index";
import ApprovalChance from "./ApprovalChance";
import CheckCardStatus from "./CheckCardStatus";
import Approval from "../CommonComponents/Approval";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

const Index = () => {
  const location = useLocation();
  const data = location.state;
  const [loading, setLoading] = useState(false);
  const [res, setResponse] = useState([]);
  const DetailHandler = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("cibil", data.cibil);
      formData.append("specified_card", data.specificCard);
      formData.append("monthly_income", data.annualIncome);
      formData.append("monthly_emi", data.monthlyemi);
      formData.append("profession", data.employmentType);
      formData.append("company", data.companyName);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/creditCardApproval`,
        formData
      );
      setResponse(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error(
        "Failed to fetch loan estimate:",
        error.response?.data || error.message
      );
      setLoading(false);
    } finally {
    }
  };

  useEffect(() => {
    DetailHandler();
  }, []);

  return (
    <>
      {loading ? (
        <Skeleton count={8} style={{ height: 40, marginTop: 20 }} />
      ) : (
        <>
          <Eligibility data={data} />
          <ApprovalChance data={{ data, res }} />
          <CheckCardStatus
            data={{
              res,
              monthlyemi: data.monthlyemi,
              specificCard: data.specificCard,
            }}
          />
          <Approval />
        </>
      )}
    </>
  );
};

export default Index;
